import { Provider, Signal } from "@angular/core";
import { ATOM_SNACKBAR_DISMISS_ARIA_LABEL } from "@atomchat-io/ui-design-system";
import { translateSignal } from "@jsverse/transloco";

/**
 * Localizes the default dismiss icon-button of `atom-snackbar`.
 *
 * Token is a `Signal<string>` and stays in sync on live language switches
 * (`reRenderOnLangChange: true`), same approach as
 * {@link provideAtomRichTextLabels}. `ATOM_SNACKBAR_DURATION` is a duration
 * number, not copy — it is not provided here.
 */
export const provideAtomSnackbarLabels = (): Provider[] => [
    {
        provide: ATOM_SNACKBAR_DISMISS_ARIA_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal("atom_snackbar.dismiss_aria_label"),
    },
];
